import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "card card-stretch shadow",
  style: {"margin-bottom":"10px"}
}
const _hoisted_2 = {
  class: "card-body",
  style: {"padding":"15px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Эхлэл")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Хэрэглэгчийн эрх")
const _hoisted_5 = { class: "row g-10" }
const _hoisted_6 = { class: "col-lg-4" }
const _hoisted_7 = { class: "card shadow" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Үүргийн жагсаалт")
], -1)
const _hoisted_10 = { class: "card-toolbar" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Нэмэх ")
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = ["data-id", "data-name"]
const _hoisted_14 = {
  key: 0,
  class: "col-lg-8"
}
const _hoisted_15 = { class: "card shadow" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Эрхийн жагсаалт")
  ])
], -1)
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = {
  key: 0,
  class: "modal modal-fullscreen fade",
  ref: "deleteRoleModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_19 = { class: "modal-dialog modal-dialog-centered mw-400px" }
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = { class: "modal-header" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", null, "Устгах уу?", -1)
const _hoisted_23 = { class: "svg-icon svg-icon-1" }
const _hoisted_24 = { class: "modal-body" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("strong", null, "Код:", -1)
const _hoisted_26 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_27 = /*#__PURE__*/_createElementVNode("strong", null, "Нэр:", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_29 = { class: "modal-footer" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Устгах ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_32 = {
  key: 1,
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "editRoleModal",
  "aria-hidden": "true",
  style: {"z-index":"1100 !important"}
}
const _hoisted_33 = { class: "modal-dialog modal-dialog-centered mw-700px" }
const _hoisted_34 = { class: "modal-content" }
const _hoisted_35 = { class: "modal-header" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", null, "Үүрэг засах", -1)
const _hoisted_37 = { class: "svg-icon svg-icon-1" }
const _hoisted_38 = { class: "modal-body" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_40 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("Болих ")
const _hoisted_43 = {
  key: 2,
  class: "modal modal-fullscreen fade",
  tabindex: "-1",
  ref: "editPermissionModal",
  "aria-hidden": "true",
  style: {"z-index":"1100 !important"}
}
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered mw-500px" }
const _hoisted_45 = { class: "modal-content" }
const _hoisted_46 = { class: "modal-header" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h2", null, "Эрх засах", -1)
const _hoisted_48 = { class: "svg-icon svg-icon-1" }
const _hoisted_49 = { class: "modal-body" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-1" }, null, -1)
const _hoisted_51 = {
  class: "row",
  style: {"padding":"10px 20px 10px 10px"}
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Хадгалах ")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Болих ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button_group = _resolveComponent("el-button-group")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_add_role = _resolveComponent("add-role")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_breadcrumb, { "separator-class": "el-icon-arrow-right" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/' } }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_el_button, {
                type: "primary",
                icon: "el-icon-plus",
                plain: "",
                size: "small",
                "data-bs-target": "#addRoleModal",
                "data-bs-toggle": "modal"
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            true
              ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  key: 0,
                  data: _ctx.roleTableData,
                  style: {"width":"100%","margin-top":"10px"},
                  border: "",
                  "element-loading-text": "Өгөгдөл татаж байна...",
                  "empty-text": "Өгөгдөл байхгүй байна.",
                  size: "mini",
                  "cell-style": { textAlign: 'center' },
                  "header-cell-style": { textAlign: 'center' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      label: "№",
                      prop: "roleid",
                      width: "40"
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Нэр",
                      sortable: ""
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("span", {
                          class: "customized-link-span",
                          "data-id": scope.row.roleid,
                          "data-name": scope.row.rolename,
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.linkToPermission && _ctx.linkToPermission(...args)))
                        }, _toDisplayString(scope.row.rolename), 9, _hoisted_13)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Тайлбар",
                      prop: "desc",
                      sortable: ""
                    }),
                    _createVNode(_component_el_table_column, {
                      label: "Үйлдэл",
                      align: "center",
                      width: "115"
                    }, {
                      default: _withCtx((props) => [
                        _createVNode(_component_el_button_group, { align: "center" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              icon: "el-icon-edit",
                              size: "mini",
                              plain: "",
                              onClick: ($event: any) => (_ctx.editroleshowbutton(props.row)),
                              type: "primary"
                            }, null, 8, ["onClick"]),
                            _createVNode(_component_el_button, {
                              icon: "el-icon-delete",
                              size: "mini",
                              plain: "",
                              "data-id": props.row.roleid,
                              "data-name": props.row.rolename,
                              onClick: _ctx.deleteroleshowbutton,
                              type: "danger"
                            }, null, 8, ["data-id", "data-name", "onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data"])), [
                  [_directive_loading, _ctx.loadingRolePerTable]
                ])
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (this.perListEnabled)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h5", null, _toDisplayString(_ctx.roleName), 1),
                _createVNode(_component_el_alert, {
                  description: "Идэвхжүүлсэн үед шууд өөрчлөлт орохыг анхаарана уу.",
                  type: "warning",
                  center: "",
                  size: "small"
                }),
                true
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                      key: 0,
                      data: this.rolePerTableData,
                      style: {"width":"100%","margin-top":"10px"},
                      border: "",
                      "element-loading-text": "Өгөгдөл татаж байна...",
                      "empty-text": "Өгөгдөл байхгүй байна.",
                      size: "mini",
                      "cell-style": { textAlign: 'center' },
                      "header-cell-style": { textAlign: 'center' }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          label: "№",
                          prop: "infotypecode",
                          sortable: "",
                          width: "60"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Нэр",
                          prop: "infotypename",
                          sortable: ""
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Эрхийн нэр",
                          prop: "trole",
                          sortable: ""
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Идэвхтэй эсэх",
                          width: "100"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_switch, {
                              onClick: ($event: any) => (
                      _ctx.onChangeSwitch(
                        scope.row.infotypecode,
                        scope.row.infostat,
                        scope.row.trole
                      )
                    ),
                              modelValue: scope.row.infostat,
                              "onUpdate:modelValue": ($event: any) => ((scope.row.infostat) = $event),
                              loading: _ctx.loadingSwitch
                            }, null, 8, ["onClick", "modelValue", "onUpdate:modelValue", "loading"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "Үйлдэл",
                          align: "center",
                          width: "90"
                        }, {
                          default: _withCtx((props) => [
                            _createVNode(_component_el_button, {
                              icon: "el-icon-edit",
                              size: "mini",
                              plain: "",
                              onClick: ($event: any) => (_ctx.editpermissionshowbutton(props.row)),
                              type: "primary"
                            }, null, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])), [
                      [_directive_loading, this.loadingRolePerTable]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_add_role, { onRefreshevent: _ctx.getRoles }, null, 8, ["onRefreshevent"]),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleterolehidebutton && _ctx.deleterolehidebutton(...args)))
                }, [
                  _createElementVNode("span", _hoisted_23, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_el_row, {
                  justify: "space-between",
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _hoisted_26,
                    _createElementVNode("p", null, _toDisplayString(this.deletemodal.roleid), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_row, {
                  justify: "space-between",
                  type: "flex"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _hoisted_28,
                    _createElementVNode("p", null, _toDisplayString(this.deletemodal.rolename), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.deleteRole())),
                      loading: this.deletemodal.buttonloader
                    }, {
                      default: _withCtx(() => [
                        _hoisted_30
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      onClick: _ctx.deleterolehidebutton
                    }, {
                      default: _withCtx(() => [
                        _hoisted_31
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {
                _ctx.editrolehidebutton();
                _ctx.editRoleClearField();
              })
                }, [
                  _createElementVNode("span", _hoisted_37, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_form, {
                  model: this.roleeditmodal.modalform,
                  ref: "editRoleForm",
                  "label-width": "220px",
                  size: "mini",
                  rules: this.roleeditmodal.modalformrule
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Нэр:",
                      prop: "rolename",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.roleeditmodal.modalform.rolename,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.roleeditmodal.modalform.rolename) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Тайлбар:",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: this.roleeditmodal.modalform.desc,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.roleeditmodal.modalform.desc) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      loading: this.roleeditmodal.editbuttonloader,
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {
                  _ctx.editRoleFormSubmit();
                  _ctx.editRole();
                })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_41
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {
                  _ctx.editrolehidebutton();
                  _ctx.editRoleClearField();
                })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_42
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true),
    true
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", {
                  class: "btn btn-sm btn-icon btn-active-color-primary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {
                _ctx.editpermissionhidebutton();
                _ctx.editPermissionClearField();
              })
                }, [
                  _createElementVNode("span", _hoisted_48, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_el_form, {
                  model: this.permissioneditmodal.modalform,
                  ref: "editPermissionForm",
                  "label-width": "100px",
                  size: "mini",
                  rules: this.permissioneditmodal.modalformrule
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Нэр:",
                      prop: "infotypename",
                      "label-width": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: this.permissioneditmodal.modalform.infotypename,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.permissioneditmodal.modalform.infotypename) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_50,
              _createElementVNode("div", _hoisted_51, [
                _createVNode(_component_el_row, {
                  type: "flex",
                  justify: "end"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      loading: this.permissioneditmodal.editbuttonloader,
                      onClick: _cache[10] || (_cache[10] = ($event: any) => {
                  _ctx.editPermissionFormSubmit();
                  _ctx.editPermission();
                })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_52
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_el_button, {
                      type: "info",
                      plain: "",
                      size: "mini",
                      class: "col-lg-3",
                      onClick: _cache[11] || (_cache[11] = ($event: any) => {
                  _ctx.editpermissionhidebutton();
                  _ctx.editPermissionClearField();
                })
                    }, {
                      default: _withCtx(() => [
                        _hoisted_53
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ], 512))
      : _createCommentVNode("", true)
  ], 64))
}